import { useTranslation } from 'react-i18next';
import './HowItWorks.css';

const STEPS = ['install', 'addTab', 'configure', 'run'] as const;

export function HowItWorks() {
  const { t } = useTranslation();

  return (
    <section id="how" className="section section--soft">
      <div className="container">
        <div className="section-header">
          <span className="eyebrow">{t('howItWorks.eyebrow')}</span>
          <h2>{t('howItWorks.title')}</h2>
          <p>{t('howItWorks.subtitle')}</p>
        </div>
        <ol className="steps">
          {STEPS.map((key, idx) => (
            <li key={key} className="step">
              <span className="step__number">{String(idx + 1).padStart(2, '0')}</span>
              <div className="step__content">
                <h3 className="step__title">{t(`howItWorks.steps.${key}.title`)}</h3>
                <p className="step__body">{t(`howItWorks.steps.${key}.body`)}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
